<template>
<div class="col-12 text-left">
    <app-nav-bar></app-nav-bar>
    <div class="main-content">
         <h3 class="p-2">
            <small class="text-muted">Product Detail</small>
        </h3>
        <div class="p-2 dropdown-divider"></div>
        <div class="row">
            <div class="form-group col-3">
                <label for="btk-Product-name">Product Name</label>
                <input type="text" class="form-control" id="btk-Product-name" v-model="product.name">
            </div>
        </div>
        <div class="row">
            <div class="form-group col-3">
                <label for="btk-Product-description">Description</label>
                <input type="text" class="form-control" id="btk-Product-description" v-model="product.description">
            </div>
        </div>
        <div class="row">
            <div class="form-group col-6">
              <label for="uom">UOM</label>
              <app-lookup-field :model="product" :element="uomLookup" v-on:selectLookup="finishLookup"></app-lookup-field>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-3">
                <label for="btk-Product-is-active">Active</label>
                <input type="checkbox" class="form-control" v-model="product.isActive" id="btk-Product-is-active">
            </div>
        </div>
        <button type="button" class="btn btn-outline-success" @click="save">Save <i class="far fa-save"></i></button>
        <button type="button" class="btn btn-outline-danger" @click="cancel">Cancel <i class="far fa-window-close"></i></button>
        <br /><br />
    </div>
</div>
</template>

<script>
import api from '../../services/api'
import { product } from '../../models/product'
import AppLookupField from '../../components/AppLookupField.vue'
import AppDatePicker from '../../components/AppDatePicker.vue'
import AppNavBar from '../../components/AppNavbar.vue'

export default {
    components: {
      AppLookupField, AppDatePicker, AppNavBar
    },
    data() {
      return {
        product: {...product},
        uomLookup: {
            id: 'uom-lookup',
            title: 'UOM',
            type: 'form',
            apiUrl: 'UOM-list',
            filter: ['code', 'name'],
            fields: [
                {
                    placeholder: 'Name',
                    width: 6,
                    column: 'uomName'
                },
            ],
            dtElements: [
                {
                title: 'Code',
                column: 'code'
                },
                {
                title: 'Name',
                column: 'name'
                },
            ],
            affectedField: [
            {
                from: 'id',
                to: 'uomId'
            },
            {
                from: 'name',
                to: 'uomName'
            }
            ]
        }
      }
    },
    async created() {
      if(this.$route.query.id !== undefined) {
        const productApi = api('product')
        this.product = await productApi.getWithParams(this.$route.query.id)
      }
    },
    methods: {
      async save() {
        const productApi = api('product')
        if(this.$route.query.id !== undefined) {
          await productApi.update(this.product, this.$route.query.id)
        } else {
          await productApi.create(this.product)
        }
        this.$router.go(-1)
      },
      cancel() {
        this.$router.go(-1)
      },
      finishLookup(data) {
        const currentProduct = this.product
        this.product = {
          ...currentProduct,
          ...data
        }
      } 
    }
}
</script>